import api from "./api";

const getSupplier = async () => {

    const response = await api.get("/api/supplier");
	console.log('test supplier');
	console.log(response);
	return response.data.data;

};

const addSupplier = async(formData)=>{
    const response = await api.post(
        "/api/supplier",
        formData
    );
    return response.data;
}

const updateSupplier = async(id,formData)=>{

    const response = await api.put(
        `/api/supplier/${id}`,
        formData
    );
    return response.data;
}

const deleteSupplier = async(id)=>{

    const response = await api.delete(`/api/supplier/${id}`);

    return response.data;

}

export default{
    getSupplier,
    addSupplier,
    updateSupplier,
    deleteSupplier
}